import { render } from "./ClientChip.vue?vue&type=template&id=8336babe&scoped=true"
import script from "./ClientChip.vue?vue&type=script&lang=js"
export * from "./ClientChip.vue?vue&type=script&lang=js"

import "./ClientChip.vue?vue&type=style&index=0&id=8336babe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8336babe"]])

export default __exports__